<template>
  <div>
    <Breadcrumbs main="Beacon" title="Application" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} Application`">
          <div class="row">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.validate ? form.rule : ''" v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <v-select v-if="form.type.match('select')" v-model="form.value" :disabled="modalData.disable"
                    :id="form.name" label="name" :options="option" multiple></v-select>
                  <b-form-textarea v-else-if="form.type.match('text-area')" v-model="form.value" rows="3"
                    :disabled="modalData.disable" :id="form.name"></b-form-textarea>
                  <b-form-input v-else :disabled="modalData.disable" v-model="form.value" :id="form.name"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <template #modal-footer>
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button variant="primary" @click="save(modalData)" :disabled="invalid"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>

      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isExport="true" v-bind:data="{
                  module: 'beacon',
                  columns: columns,
                  rows: rows,
                  exportDetail: exportDetail,
                  filter_col: [0, 3],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      option: [],
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      show: false,
      columns: [
        {
          label: 'Application Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Type',
          field: 'type',
          hidden: false,
        },
        {
          label: 'Description',
          field: 'description',
          hidden: false,
        },
        {
          label: 'Group',
          field: 'group',
          hidden: false,
        },

        {
          label: 'Update Date',
          field: 'updated_at',
          hidden: false,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      rows: [],
      form: [
        {
          value: '',
          col: 12,
          name: 'Application Name',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'Type',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'Group',
          type: 'select',
          validate: true,
          rule: 'required'
        },
        {
          value: '',
          col: 12,
          name: 'Description',
          type: 'text-area',
          validate: true,
          rule: 'customRegex|max_length200'
        },
      ],
      exportDetail: {
        fileName: 'export_application',
        exportUrl: '',
      },
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  mounted() {
    // this.loadColumn();
    setTimeout(() => this.loadItems(), 1000);
    this.groupOption();
  },
  methods: {
    deleteRow(value) {
      const url = `/api/application/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('beacon', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    save(value) {
      let data = this.form.map((item) => item.value);
      var group = [];
      data[2].forEach((element) => {
        group.push(element._id);
      });
      this.show = !this.show;
      // const url = `/api/application`;
      const url = `/api/application${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      const object = {
        name: data[0],
        type: data[1],
        group: group,
        description: data[3],
      };
      requestService
        .PostFetch('beacon', url, object)
        .then((res) => {
          this.$swal.fire({
            icon: 'success',
            title: 'Application has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    async groupOption() {
      let url = `/api/group/all`;
      const resGroup = await requestService.GetFetch('beacon', url);
      const group = await resGroup.json();
      this.option = group.data;
    },
    openModal(value, id) {
      this.modalData.row = id;

      this.modalData.title = value;

      this.show = !this.show;
      if (!value.match('Add')) {
        this.form[0].value = id.row.name;
        this.form[1].value = id.row.type;
        this.form[2].value = id.row.group;
        this.form[3].value = id.row.description;
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }
      var url = '/api/application/filter?' + str;
      this.exportDetail.exportUrl = '/api/application/export?' + str;
      return requestService
        .GetFetch('beacon', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style></style>
